import PageWithSidebar from '@/src/Common/components/PageWithSidebar';
import usePhotoEngineerStats from './hooks/usePhotoEngineerStats';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/src/shadComponents/ui/card';
import { Loader2 } from 'lucide-react';

export default function PhotoEngineerStats() {
    const { stats, isLoading } = usePhotoEngineerStats();

    return (
        <PageWithSidebar title="PhotoEngineer Stats" subtitle="Stats">
            {isLoading ? (
                <div className="flex items-center justify-center py-12">
                    <Loader2 className="size-6 animate-spin text-muted-foreground" />
                </div>
            ) : (
                <Card className="mx-4">
                    <CardHeader>
                        <CardTitle>Signup Stats</CardTitle>
                        <CardDescription>Signup stats for the last day</CardDescription>
                    </CardHeader>
                    <CardContent>
                        {stats && (
                            <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                                <Card>
                                    <CardHeader className="pb-2">
                                        <CardTitle className="text-sm font-medium text-muted-foreground">Day</CardTitle>
                                    </CardHeader>
                                    <CardContent>
                                        <div className="text-2xl font-bold">{stats.day}</div>
                                    </CardContent>
                                </Card>
                                <Card>
                                    <CardHeader className="pb-2">
                                        <CardTitle className="text-sm font-medium text-muted-foreground">Week</CardTitle>
                                    </CardHeader>
                                    <CardContent>
                                        <div className="text-2xl font-bold">{stats.week}</div>
                                    </CardContent>
                                </Card>
                                <Card>
                                    <CardHeader className="pb-2">
                                        <CardTitle className="text-sm font-medium text-muted-foreground">Month</CardTitle>
                                    </CardHeader>
                                    <CardContent>
                                        <div className="text-2xl font-bold">{stats.month}</div>
                                    </CardContent>
                                </Card>
                                <Card>
                                    <CardHeader className="pb-2">
                                        <CardTitle className="text-sm font-medium text-muted-foreground">Year</CardTitle>
                                    </CardHeader>
                                    <CardContent>
                                        <div className="text-2xl font-bold">{stats.year}</div>
                                    </CardContent>
                                </Card>
                            </div>
                        )}
                    </CardContent>
                </Card>
            )}
        </PageWithSidebar>
    );
}
